import { popinApiV2 } from 'src/api/api';

const authApi = {

  authGuest: () => {
    // return Promise.resolve().then(() => {
    return popinApiV2.post('/auth/guest');
    // }).catch(error => {
    //   // This will be handled in the saga
    //   return { collectionsError: error };
    // })
  },

  create: function(account) {
    return popinApiV2.post(`/auth/create`, {
      email: account.email,
      givenName: account.givenName,
      familyName: account.familyName,
      reason: account.reason,
    });
  },

}

export default authApi
